<template>
  <div>
    <slot name="label">
      <label v-if="label" class="col-form-label" :class="labelClasses">
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
      </label>
    </slot>

    <slot>
      <v-text-field
        :class="inputClasses"
        v-bind="$attrs"
        v-model="inputVal"
        :rows="rows"
        :rules="rules"
      ></v-text-field>
    </slot>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'base-input',
  props: {
    required: {
      type: Boolean,
      description: 'Whether input is required (adds an asterix *)',
    },
    valid: {
      type: Boolean,
      description: 'Whether is valid',
      default: undefined,
    },
    label: {
      type: String,
      description: 'Input label (text before input)',
    },
    name: {
      type: String,
      description: 'Input name ',
    },
    helpText: {
      type: String,
      description: 'Input help text (text after input)',
    },

    labelClasses: {
      type: String,
      description: 'Input label css classes',
    },
    inputClasses: {
      type: String,
      description: 'Input css classes',
    },
    value: {
      type: [String, Number],
      description: 'Input value',
    },
    addonRightIcon: {
      type: String,
      description: 'Addon right icon',
    },
    icon: {
      type: String,
      description: ' left icon',
    },
    errors: {
      default: null,
    },
    rules: {
      description: ' input rules',
    },
    rows: {
      default: '3',
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {},
};
</script>
<style></style>
